import { useEffect } from "react";
import { GAME_SETTINGS_CHANGED } from "../local/gameSettings";
import { enableMenuMusicOnUserAction, refreshAudioSettings, sfx, startMenuMusic, stopMenuMusic } from "../game/audio";

export function MenuMusic({ active }: { active: boolean }) {
  useEffect(() => {
    refreshAudioSettings();
    if (active) startMenuMusic();
    else stopMenuMusic();
    return () => {
      if (!active) stopMenuMusic();
    };
  }, [active]);

  // Auto-unlock menu music on the first user gesture while a menu is
  // showing. Previously the only enable site was the lobby Play button —
  // any deep-linked / re-entered menu screen never got music until the
  // user happened to click that specific button. Browsers still require a
  // user gesture, so we listen for the first pointer / key and flip the
  // gate exactly once.
  useEffect(() => {
    if (!active) return;
    const unlock = () => enableMenuMusicOnUserAction();
    document.addEventListener("pointerdown", unlock, { once: true });
    document.addEventListener("keydown", unlock, { once: true });
    return () => {
      document.removeEventListener("pointerdown", unlock);
      document.removeEventListener("keydown", unlock);
    };
  }, [active]);

  useEffect(() => {
    const onSettings = () => {
      refreshAudioSettings();
      if (active) startMenuMusic();
    };
    window.addEventListener(GAME_SETTINGS_CHANGED, onSettings);
    return () => window.removeEventListener(GAME_SETTINGS_CHANGED, onSettings);
  }, [active]);

  useEffect(() => {
    if (!active) return;
    const onPointerUp = (event: PointerEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const control = target.closest("button, a, [role='button']");
      if (control) sfx.menu();
    };
    document.addEventListener("pointerup", onPointerUp, true);
    return () => document.removeEventListener("pointerup", onPointerUp, true);
  }, [active]);

  return null;
}
